<template>
  <div class="card p-2" style="min-height: calc(100vh - 185px);">
      <div class="d-flex flex-wrap justify-content-between align-item-center">
          <h3>Activity Setup</h3>
          <div class="gx-1">
              <button
                  @click="onClickToOpenModal('group')"
                  class="btn btn-primary waves-effect waves-float waves-light me-1"
              >Add Group
              </button>
          </div>
      </div>
      <div class="mt-2"></div>
      <hr>
      <TreeBrowser
          v-for="(item, i) in activityList"
          :key="i"
          :node="item"
      />

      <ActivityAddOrEditModal
        v-if="store.state.isModalOpen"
        :title="title"
        :activityType="activityType"
        :statusList="statusList"
        @onSubmit="getActivityTree"
        :parent="parent"
        :editData="singleActivity"
      />

      <p v-if="!activityList.length" class="text-center mt-5">No data</p>  
      
      <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import handleActivity from '@/services/modules/procurement/activity';

import TreeBrowser      from '@/components/molecule/procurement/activity/ActivityTreeBrowser'
import TitleButton      from '@/components/atom/TitleButton'
import Loader           from '@/components/atom/LoaderComponent'
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getCurrentInstance } from 'vue';
import ActivityAddOrEditModal from '@/components/molecule/procurement/activity/ActivityAddOrEditModal'
import { useStore } from 'vuex';
import handleChartAccount from '@/services/modules/chartAccount';

const { appContext } = getCurrentInstance()
const emitter = appContext.config.globalProperties.emitter
const store = useStore();

const { fetchActivityTree, fetchSingleActivity } = handleActivity();
const { fetchHome } = handleChartAccount();
const route = useRoute();
const activityList = ref([]);
const statusList = ref([]);
const loading = ref(false);
const title = ref('');
const activityType = ref('');
const parent = ref(null);
const singleActivity = ref(null);

const onClickToOpenModal = (headType = 'group') => {
  singleActivity.value = null;
  activityType.value = headType;
  title.value = headType === 'group' ? 'Add Activity Group' : 'Add Activity Head';
  store.state.isModalOpen = true;
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    return query;
}

const getStatusList = async () => {
    await fetchHome().then(res => {
      statusList.value = [];

      if (! res.status) return

      if (! res.data || ! res.data.status) return

      const statusType = res.data.status;
      statusList.value = ['active', 'inactive'].map(key => ({
        value: key,
        name: statusType[key],
      }));
    })
}

const getActivityTree = async () => {
    const query = getQuery();
    loading.value = true

    await fetchActivityTree(query).then(res => {
        
      activityList.value = [];

      if (res.status){
        activityList.value = res.data;
      }
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getSingleActivity = async (id) => {
        
    singleActivity.value = null;

    const query = getQuery();
    loading.value = true

    await fetchSingleActivity(id, query).then(res => {
      if (res.status){
        singleActivity.value = res.data;
      }
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const handleAddGroup = (data) => {
  parent.value = data;
  activityType.value = 'childGroup';
  singleActivity.value = null;
  store.state.isModalOpen = true;
}

const handleAddLocation = (data) => {
  parent.value = data;
  activityType.value = 'endpoint';
  singleActivity.value = null;
  store.state.isModalOpen = true;
}

const handleGroupUpdate = async (data) => {
  await getSingleActivity(data.data.id);

  parent.value = null;

  if(singleActivity.value && singleActivity.value.parent) {
    parent.value = singleActivity.value.parent;
  }

  activityType.value = 'group';
  title.value = 'Edit Activity Group';
  store.state.isModalOpen = true;
}

const handleLocationUpdate = async (data) => {
  await getSingleActivity(data.data.id);

  parent.value = null;

  if(singleActivity.value && singleActivity.value.parent) {
    parent.value = singleActivity.value.parent;
  }

  activityType.value = 'endpoint';
  title.value = 'Edit Activity Head';
  store.state.isModalOpen = true;
}

onMounted(() => {
  getActivityTree();
  getStatusList();

  emitter.on('onClickAddGroup', handleAddGroup)
  emitter.on('onClickAddLocation', handleAddLocation)
  emitter.on('onGroupUpdate', handleGroupUpdate)
  emitter.on('onLocationUpdate', handleLocationUpdate)
})

onUnmounted(() => {
  emitter.off('onClickAddGroup', handleAddGroup)
  emitter.off('onClickAddLocation', handleAddLocation)
  emitter.off('onGroupUpdate', handleGroupUpdate)
  emitter.off('onLocationUpdate', handleLocationUpdate)
})

</script>
  